import { useQuery } from "react-query";
import { listBusinesses, type BusinessListItem } from "service/business";

export const APPLICATIONS_KEY = "business-applications";

export function useApplications(enabled = true) {
  return useQuery<BusinessListItem[]>({
    queryKey: [APPLICATIONS_KEY],
    queryFn: listBusinesses,
    enabled,
    refetchOnWindowFocus: false,
    retry: 1,
    retryDelay: 500,
  });
}

/** Rows that need a reviewer: the count on the tab and the card. */
export const isWaiting = (b: BusinessListItem) =>
  b.state === "submitted" || b.state === "in_review";
